import { render, staticRenderFns } from "./PodrEditAppr.vue?vue&type=template&id=b2c89e6c&scoped=true&"
import script from "./PodrEditAppr.vue?vue&type=script&lang=js&"
export * from "./PodrEditAppr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c89e6c",
  null
  
)

export default component.exports